import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

@Injectable()
export class CaptureAggregateService extends ApiService {
  constructor(private http: Http) {
    super('api/captures-report/', http);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/capture-aggregate.service.ts